import React, { useState, useMemo } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { RoleData } from "types/models/master/MasterApp";
import AppTableContainer from "@crema/core/AppTableContainer";

interface RoleTableProps {
  roles: RoleData[];
}

const RoleTable: React.FC<RoleTableProps> = ({ roles }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RoleData>("role");

  const handleSort = (property: keyof RoleData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedRoles = useMemo(() => {
    return [...roles].sort((a, b) => {
      const aVal = a[orderBy];
      const bVal = b[orderBy];

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === "string") {
        return order === "asc"
          ? aVal.localeCompare(bVal as string)
          : (bVal as string).localeCompare(aVal);
      }

      if (typeof aVal === "number") {
        return order === "asc"
          ? (aVal as number) - (bVal as number)
          : (bVal as number) - (aVal as number);
      }

      if (typeof aVal === "boolean") {
        return order === "asc"
          ? Number(aVal) - Number(bVal)
          : Number(bVal) - Number(aVal);
      }

      return 0;
    });
  }, [roles, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSort} />
        </TableHead>
        <TableBody>
          {sortedRoles.map((data) => (
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default RoleTable;
